import _styled from '@emotion/styled/base';
import * as CoachMarkPrimitive from '@radix-ui/react-popover';
import * as React from 'react';
import { Text } from '../Text/index.js';
import { CoachMarkContentStyles, CoachMarkArrowStyles } from './styles.js';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import { spacing } from '@hubble/tokens/web';

const CoachMarkRoot = _styled(CoachMarkPrimitive.Root, {
  target: "ede6yhv0"
})();
const CoachMarkPortal = CoachMarkPrimitive.Portal;
const CoachMarkContent = React.forwardRef(({
  align = 'start',
  children,
  ...props
}, ref) => {
  const arrowOffset = parseInt(spacing[12]) / 2;
  return jsxs(CoachMarkContentStyles, {
    ref: ref,
    align: align,
    arrowPadding: arrowOffset,
    ...props,
    children: [jsx(Text.Body, {
      size: "xs",
      bold: true,
      color: "currentColor",
      children: children
    }), jsx(CoachMarkArrowStyles, {
      height: 8,
      width: 16
    })]
  });
});
const CoachMarkTrigger = React.forwardRef(({
  children,
  ...props
}, ref) => jsx(CoachMarkPrimitive.Trigger, {
  asChild: true,
  ref: ref,
  ...props,
  children: children
}));
const CoachMarkAnchor = React.forwardRef(({
  children,
  ...props
}, ref) => jsx(CoachMarkPrimitive.Anchor, {
  asChild: true,
  ref: ref,
  ...props,
  children: children
}));
const CoachMark = Object.assign(CoachMarkRoot, {
  Content: CoachMarkContent,
  Trigger: CoachMarkTrigger,
  Anchor: CoachMarkAnchor,
  Portal: CoachMarkPortal
});
CoachMark.displayName = 'CoachMark';

export { CoachMark };
